import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import { FloatingLabel } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';



const MyFooter = ({ handleSaveNew, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='primary'>Apply</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};

const AdjustmentReason = ({create, success}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [info, setInfo] = useState();
  const navigate = useNavigate();

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  

  const handleSaveNew = () => {
    // addEntry();
    save();
  };

  const save = async () => {
    try {
      const row = await form.validateFields();
      // console.log(row)
      if (Array.isArray(info)) {
        info.forEach((_, id) => {
          info[id]['reference'] = row.inventory_reason;
        });
      }else {
        info['reference'] = row.inventory_reason;
      }
      // let info_ = {...info};
      // info_['account_date'] = dayjs(info.accounting_date, 'YYYY-MM-DD');
      info.accounting_date = new Date(info.accounting_date).toISOString();
      // console.log(info);
      // console.log(info)
      await create(info, success)
      form.resetFields();
      setIsModalOpen(false);
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }

  

  useEffect(() => {
    EventEmitter.subscribe('openinvenreason', info => {
      const { open, data } = info;
      // console.log(Array.isArray(data));
      setInfo(data);
      setIsModalOpen(open)  
    });

    EventEmitter.subscribe('openproinvenreason', info => {
      const {open, data } = info;
      setInfo(data);
      setIsModalOpen(open);
    });
    
    return () => {
      EventEmitter.unsubscribe('openinvenreason');
      EventEmitter.unsubscribe('openproinvenreason');
    }
  },[])

  const handleSaveClose = () => {
    save();
    handleCancel();
  }



  return (
    <Modal title="Inventory Adjustment" className='p-0 ' open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveNew={handleSaveNew} handleSaveClose={handleSaveClose}/>}>
      <Form 
        form={form}
        className='pt-5 border-t-2 mt-3' 
        labelAlign='left'
        labelCol={{span: 8}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Inventory Reason' name="inventory_reason" className='font-semibold text-gray-800 mb-4' required>
          <Input type='text' className='input-outline-none'/>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AdjustmentReason;